class LovService {

    $lv

    get $http() {
        return this.httpKey ? this.$lv.Vue.prototype[this.httpKey] : this.$lv.Vue.prototype.$http
    }

    lovMap = {}                         //值列表
    queryTypeMap = {}                   //要查询的值列表类型数组
    delayTimer = null                   //延迟查询定时器
    resolve = null                      //临时变量

    constructor($lv, httpKey) {
        this.$lv = $lv
		this.httpKey = httpKey
    }

    /**
     * 同时获取多个值列表
     * @author  韦胜健
     * @date    2019/6/18 11:52
     * @param   types   值列表类型数组：['ACCT_TYPE','ACCT_STAGE','ACCNT_EMAIL_PRIORITY']
     */
    async getLovTypes(types) {
        const ret = await Promise.all(types.map(type => this.getLovByType(type)))
        return ret.reduce((ret, lovs, index) => {
            ret[types[index]] = lovs
            return ret
        }, {})
    }

    /**
     * 根据值列表类型获取值列表
     * @author  韦胜健
     * @date    2019/6/5 10:38
     * @param   lovType 值列表类型
     */
    async getLovByType(lovType) {
        if (!lovType) {
            console.warn('值列表类型不能为空！')
            return
        }
        return this.lovMap[lovType] || await this.queryLovByType(lovType)
    }

    /**
     * 根据值列表的类型以及独立源代码获取值列表的名称
     * @author  韦胜健
     * @date    2018/11/27 20:58
     * @param   type    值列表类型
     * @param   val     值列表独立源代码
     */
    async getNameByTypeAndVal(type, val) {
        if (!val) return ''
        const typeLovs = await this.getLovByType(type)
        if (!!typeLovs && typeLovs.length > 0) {
            for (let i = 0; i < typeLovs.length; i++) {
                const typeLov = typeLovs[i];
                if (typeLov.val == val) {
                    return typeLov.name
                }
            }
        }
        console.warn(`找不到类型为[${type}],值为[${val}]的值列表，该值类型为${LinkUtils.typeOf(val)}`)
        return val
    }

    /**
     * 根据显示值以及类型获取独立源代码
     * @author  韦胜健
     * @date    2019/10/14 9:53
     * @param   type    值列表类型
     * @param   name    值列表显示值
     */
    async getValByTypeAndName(type, name) {
        if (!name) return
        const typeLovs = await this.getLovByType(type)
        if (!!typeLovs && typeLovs.length > 0) {
            for (let i = 0; i < typeLovs.length; i++) {
                const typeLov = typeLovs[i];
                if (typeLov.name == name) return typeLov.val
            }
        }
        console.warn(`找不到类型为[${type}],显示值为[${name}]的值列表，该值类型为${LinkUtils.typeOf(name)}`)
        return name
    }

    /**
     * 根据要匹配的显示值以及类型获取独立源代码数组
     * @author  韦胜健
     * @date    2019/10/14 10:08
     */
    async getValsByTypeAndMatchName(type, matchName) {
        if (!matchName) return
        const ret = []
        const typeLovs = await this.getLovByType(type)
        if (!!typeLovs && typeLovs.length > 0) {
            for (let i = 0; i < typeLovs.length; i++) {
                const typeLov = typeLovs[i];
                if (typeLov.name.indexOf(matchName) > -1) ret.push(typeLov.val)
            }
        }
        return ret
    }

    /**
     * 根据值列表类型查询值列表数据
     * @author  韦胜健
     * @date    2018/11/27 19:28
     */
    async queryLovByType(lovType) {
        if (!!this.queryTypeMap[lovType]) {
            /*当前正在查询，等待查询完毕*/
            while (!!this.queryTypeMap[lovType]) {
                await LinkUtils.delay(500)
            }
            return this.lovMap[lovType]
        } else {
            this.queryTypeMap[lovType] = true
            this.startQuery()
            return this.queryLovByType(lovType)
        }
    }

    /**
     * 开始查询值列表
     * @author  韦胜健
     * @date    2019/6/5 10:39
     */
    async startQuery() {
        if (!!this.delayTimer) clearTimeout(this.delayTimer)

        this.delayTimer = setTimeout(async () => {
            await this.$lv.nextTick()

            const url = `action/${LinkVue.prefixUrl}/basic/listOfVal/types?link=true`
            const types = Object.keys(this.queryTypeMap)
            const param = {types: `"[${types.join(',')}]"`}
            const data = await this.$http.post(url, param, true)
            if (!data.success) {
                console.error('值列表查询失败！')
                console.error(data)
                return
            }
            const dataLovs = data.rows.reduce((ret, item) => {
                !ret[item.type] && (ret[item.type] = [])
                ret[item.type].push(item)
                return ret
            }, {})
			types.forEach(type => !dataLovs[type] && (dataLovs[type] = []))
            Object.assign(this.lovMap, dataLovs)
            types.forEach(type => delete this.queryTypeMap[type])
        }, 1000)
    }


    /**
     * 根据父值列表的类型以及值获取值列表数组
     * @author  韦胜健
     * @date    2019/4/1 15:58
     */
    async getLovByParentTypeAndValue(lovType, parentLovType, parentLovValue) {
        const lovs = await this.getLovByType(lovType)
        if (!lovs) return []
        return lovs.filter(lov => lov.parentType === parentLovType && lov.parentVal === parentLovValue)
    }

    /**
     * 获取值列表数据，并计算出默认值
     * @author  韦胜健
     * @date    2019/6/18 09:51
     */
    async getLovData(lovType, parentLovType, parentLovValue, excludeLovValArray, multiple) {
        let allLovs = await this.getLovByType(lovType)
        allLovs = this.$lv.$utils.deepCopy(allLovs)
        if (!allLovs) {
            allLovs = []
        } else {
            if (!!parentLovType) {
                allLovs = allLovs.filter(lov => lov.parentType === parentLovType && lov.parentVal === parentLovValue)
            }
            if (!!excludeLovValArray && excludeLovValArray.length > 0) {
                allLovs = allLovs.filter(lov => excludeLovValArray.indexOf(lov.val) === -1)
            }
        }

        let defaultVal;
        if (!multiple) {
            const defaultLov = this.$lv.$utils.findOne(allLovs, item => item.defaultValue === 'Y')
            defaultVal = !!defaultLov ? defaultLov.val : null
        } else {
            const defaultLovs = this.$lv.$utils.findSome(allLovs, item => item.defaultValue === 'Y')
            defaultVal = !!defaultLovs && defaultLovs.length > 0 ? defaultLovs.map(item => item.val) : null
        }

        return {lovs: allLovs, defaultVal}
    }

}

export {LovService}
